import { Component, Input, OnChanges } from '@angular/core';

@Component({
	selector: 'app-btn-save',
	template: `<button type="submit" class="btn btn-primary btn-save pill {{className}}" [disabled]="isDisabled">
		<fa-icon *ngIf="icon" class="mr-2" [icon]="['fas', icon]"></fa-icon>
		<span>{{text}}</span>
	</button>`
})
export class BtnSaveComponent implements OnChanges {

	@Input() text: string = 'Save';
	@Input() icon: string = '';
	@Input() className: string = '';
	@Input() isDisabled: boolean = false;

	constructor() {}

	ngOnChanges():void{
		//console.log('BtnSaveComponent.isDisabled:', this.isDisabled);
	}
}
